import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FiMessageCircle } from 'react-icons/fi';
import { useTelegram } from '../../hooks/useTelegram';

const Page = styled.div`
  min-height: 100vh;
  background: #0a0a0f;
  padding: 16px;
  padding-bottom: 90px;
`;

const Title = styled.h1`
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 4px;
`;

const Sub = styled.p`
  color: rgba(255,255,255,0.4);
  font-size: 13px;
  margin-bottom: 28px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Card = styled.a`
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  display: block;
  aspect-ratio: 3/4;
  position: relative;
  transition: transform 0.2s;
  &:active { transform: scale(0.97); }
`;

const CardBg = styled.div`
  position: absolute;
  inset: 0;
  background: ${p => p.$bg || '#1a1a2e'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardIcon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.3));
`;

const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(0deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 40%, transparent 60%);
`;

const CardInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 14px;
`;

const CardName = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 6px;
`;

const CardAction = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #006FFF;
  font-weight: 600;
`;

const XBOX_ITEMS = [
  { id: 'gamepass', icon: '/icons/gamepass.svg', name: 'Game Pass Ultimate', desc: 'Подписка на 500+ игр', bg: 'linear-gradient(135deg, #107C10 0%, #0a5a0a 100%)', route: '/xbox/gamepass' },
  { id: 'xbox-games', icon: '/icons/xbox.svg', name: 'Игры Xbox', desc: 'Покупка игр Xbox', bg: 'linear-gradient(135deg, #0e7a0d 0%, #085a08 100%)' },
  { id: 'xbox-wallet', icon: '/icons/xbox.svg', name: 'Пополнение Xbox', desc: 'Пополнение кошелька', bg: 'linear-gradient(135deg, #2d7d2d 0%, #1a5c1a 100%)' },
];

const ORDER_URL = 'https://t.me/openps_support';

const Xbox = () => {
  const navigate = useNavigate();
  const { tg, hapticFeedback } = useTelegram();

  useEffect(() => {
    const goBack = () => navigate('/');
    if (tg) {
      tg.setHeaderColor('#0a0a0f');
      tg.BackButton.show();
      tg.BackButton.onClick(goBack);
    }
    return () => { if (tg) { tg.BackButton.offClick(goBack); tg.BackButton.hide(); } };
  }, [tg, navigate]);

  return (
    <Page>
      <Title>🎮 Xbox</Title>
      <Sub>Game Pass, игры и пополнение кошелька Xbox</Sub>

      <Grid>
        {XBOX_ITEMS.map(item => (
          <Card key={item.id} href={item.route ? undefined : ORDER_URL} target={item.route ? undefined : "_blank"} onClick={() => { hapticFeedback?.('light'); if (item.route) navigate(item.route); }}>
            <CardBg $bg={item.bg}>
              <CardIcon src={item.icon} alt={item.name} />
            </CardBg>
            <CardOverlay />
            <CardInfo>
              <CardName>{item.name}</CardName>
              <CardAction><FiMessageCircle size={11} /> Заказать</CardAction>
            </CardInfo>
          </Card>
        ))}
      </Grid>
    </Page>
  );
};

export default Xbox;
